import request from '../../../helpers/request';

const changeHouseStage = async (values) => {
  const { houseId, stageId } = values;
  const response = await request.put(
    `/FlatsGrid/house_stage`,
    { houseId, stageId },
    `При изменении статуса дома произошла ошибка`
  );

  return response;
};

export default changeHouseStage;
